import { render } from "./EmployeeAvatar.vue?vue&type=template&id=2daa7c9a&scoped=true"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=js"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=js"

import "./EmployeeAvatar.vue?vue&type=style&index=0&id=2daa7c9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daa7c9a"]])

export default __exports__